import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { scrollToSection } from "@/lib/scroll";
import Navbar from "@/components/site/Navbar";
import VersosParaLlevar from "@/pages/VersosParaLlevar";
import PoemPage from "@/pages/PoemPage";
import FloatingWrite from "@/components/site/FloatingWrite";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Biography from "@/components/site/Biography";
import Books from "@/components/site/Books";
import Poems from "@/components/site/Poems";
import VideoPoetry from "@/components/site/VideoPoetry";
import Songs from "@/components/site/Songs";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Home = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const vid = searchParams.get("ver-video");
        if (vid) {
            scrollToSection("#video-poesia");
            setTimeout(
                () => window.dispatchEvent(new CustomEvent("show-video", { detail: vid })),
                500
            );
            searchParams.delete("ver-video");
        }
        const sid = searchParams.get("escuchar");
        if (sid) {
            scrollToSection("#canciones");
            setTimeout(
                () => window.dispatchEvent(new CustomEvent("play-song", { detail: sid })),
                500
            );
            searchParams.delete("escuchar");
        }
        if (vid || sid) setSearchParams(searchParams, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main>
            <Navbar />
            <Hero />
            <Marquee />
            <Biography />
            <Books />
            <Poems />
            <VideoPoetry />
            <Songs />
            <Contact />
            <Footer />
            <FloatingWrite />
        </main>
    );
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App">
            <div className="grain-overlay" aria-hidden="true" />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/versos-para-llevar" element={<VersosParaLlevar />} />
                    <Route path="/poema/:id" element={<PoemPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#1C1B1A",
                        color: "#FBF9F5",
                        border: "1px solid #A63D2E",
                        fontFamily: "'Space Mono', monospace",
                        fontSize: "12px",
                        letterSpacing: "0.08em",
                    },
                }}
            />
        </div>
    );
}

export default App;
